import { useRef, useState } from 'react';
import MainImageCarousel from './main-image-carousel';
import ProductThumbnails from './product-thumbnails';

interface props {
  gallery: any[];
  videoUrl: string;
  productName: string;
  seoColorLabel: string;
}

const Index = (props: props) => {
  const { gallery, videoUrl, productName, seoColorLabel } = props;

  const [activeIndex, setActiveIndex] = useState(0);
  const prevPropsRef = useRef({ gallery });

  if (prevPropsRef.current.gallery !== gallery) {
    const shouldResetIndex =
      prevPropsRef.current.gallery.length !== gallery.length ||
      prevPropsRef.current.gallery.some((x, i) => x?.image !== gallery[i]?.image);

    prevPropsRef.current.gallery = gallery;

    if (shouldResetIndex) {
      setActiveIndex(0);
    }
  }

  return (
    <div className='items-start lg_flex lg_gap-[24px]'>
      <ProductThumbnails
        images={gallery}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        videoUrl={videoUrl}
        productName={productName}
        className='hidden lg_block'
        seoColorLabel={seoColorLabel}
      />
      <MainImageCarousel
        images={gallery}
        videoUrl={videoUrl}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        productName={productName}
        seoColorLabel={seoColorLabel}
      />
    </div>
  );
};

export default Index;
